module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-italic-pro-1c929a4932f947bde580b9b559d0891a.woff";